import { useFormContext, validationsStore } from '@apia/validations';
import { TApiaApiField } from '../ApiaApiHandler';
import { useCallback, useEffect, useId, useState } from 'react';
import { ApiaUtil, LabelBox, SimpleButton, useModal } from '@apia/components';
import { EventEmitter, TApiaFilter, getLabel } from '@apia/util';
import { Box, Label, spacing } from '@apia/theme';
import { responsiveTableStore } from '@apia/table';
import { ApiaTasksModal } from '../modals/apia/components/ApiaTasksModal';
import { FiltersModal } from '../modals/apia/components/util/FiltersModal';

export const ApiaTasksModalEmitter = new EventEmitter<{
  deleteFilters: TApiaFilter[];
}>();

export const ApiaApiTasksModalField = (props: TApiaApiField) => {
  const { name } = useFormContext();
  const [selectedRows, setSelectedRows] = useState<
    { id: string; title: string }[]
  >(
    props.element.value
      .split('#')
      .filter((tsk) => tsk !== '')
      .map((tskData) => {
        const id = tskData.split('_$_')[0];
        const title = tskData.split('_$_')[1];

        return {
          id,
          title,
        };
      }),
  );
  const {
    isLoading: isFiltersModalLoading,
    show: showFiltersModal,
    ...filtersModalProps
  } = useModal();

  const id = useId();

  const deleteFilters = useCallback(() => {
    const newFilters: TApiaFilter[] = tasksModal.filters?.map(
      (currentFilter) => {
        return {
          ...currentFilter,
          currentValue: '',
          deleteFiltersTimestamp: Date.now(),
        };
      },
    );
    ApiaTasksModalEmitter.emit('deleteFilters', newFilters);
  }, []);

  useEffect(() => {
    validationsStore.setFieldValue(
      name,
      props.element.name,
      selectedRows.map((e) => e.id).join('#'),
    );
  }, [name, props.element.name, selectedRows]);

  return (
    <>
      <Label>{getLabel(props.element.text).text}</Label>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: spacing(3),
        }}
      >
        <Box
          sx={{
            maxHeight: '200px',
            overflow: 'auto',
            width: '100%',
            display: 'flex',
            flexWrap: 'wrap',
          }}
        >
          {selectedRows.map((row) => {
            return (
              <LabelBox
                key={row.id}
                label={row.title}
                onClose={() => {
                  setSelectedRows((prev) => {
                    return prev.filter((prevRow) => {
                      return prevRow.id !== row.id;
                    });
                  });
                }}
              />
            );
          })}
        </Box>
        <SimpleButton
          onClick={() => {
            ApiaUtil.instance.modals.open({
              onConfirm: () => {
                const rows =
                  responsiveTableStore.getState().responsiveTableSlice[id].rows;
                const selectedIndex =
                  responsiveTableStore.getState().responsiveTableSlice[id]
                    .selectedRows;

                const selectedRows: { id: string; title: string }[] = [];

                selectedIndex.forEach((i) => {
                  if (rows[i]) {
                    selectedRows.push({
                      id: rows[i].id,
                      title: rows[i].cells[1].children as string,
                    });
                  }
                });
                setSelectedRows((prev) => [
                  ...prev,
                  ...selectedRows.filter((newEnv) => {
                    return !prev.find((prevEnv) => prevEnv.id === newEnv.id);
                  }),
                ]);
              },
              confirmProps: { confirmButtonText: getLabel('btnCon').text },
              children: (
                <ApiaTasksModal
                  {...filtersModalProps}
                  initialProps={props.element}
                  tableName={id}
                />
              ),
              size: 'xxl',
              title: environmentsModal.label,
              NavBar: (
                <>
                  <SimpleButton
                    variant={'outline-sm'}
                    title={window.FILTERS_LABEL}
                    onClick={() => {
                      ApiaUtil.instance.modals.open({
                        children: <FiltersModal tableName={id} />,
                        variant:
                          'layout.common.modals.tableModal.additionalFiltersModal',
                        size: 'xl',
                        noHeader: true,
                        initialFocusGetter(modalInnerRef) {
                          return modalInnerRef.querySelector(
                            'select',
                          ) as HTMLElement;
                        },
                      });
                    }}
                    isLoading={isFiltersModalLoading}
                  >
                    {window.FILTERS_LABEL}
                  </SimpleButton>
                  <SimpleButton
                    variant={'outline-sm'}
                    onClick={deleteFilters}
                    title={window.BTN_DELETE_FILTERS}
                  >
                    {window.BTN_DELETE_FILTERS}
                  </SimpleButton>
                </>
              ),
            });
          }}
          sx={{
            width: 'fit-content !important',
          }}
        >
          {getLabel('lblAdd').text}
        </SimpleButton>
      </Box>
    </>
  );
};
